<template>
  <v-container
    fluid
    grid-list-lg
  >
    <NotPermission v-if="!$can('list', 'Registereds')" />
  <v-dialog v-model="dialogCambioVisible" max-width="480">
	<v-card>
		<v-layout row wrap>
			<v-flex xs12>
				<v-autocomplete
				  v-model="change.type_exam_id"
				  :items="exams"
				  label="SELECCIONAR MODALIDAD"
				  item-text="title"
				  item-value="id"
				/>
			</v-flex>
			<v-flex xs12>
				<v-autocomplete
				  v-model="change.career_id"
				  :items="careers"
				  label="SELECCIONAR ESCUELA PROFESIONAL"
				  item-text="title"
				  item-value="id"
				/>
			</v-flex>
		</v-layout>
		<v-card-actions>
			<v-btn
			  color="primary"
			  flat
			  @click="dialogCambioVisible = false"
			>
			  CANCELAR
			</v-btn>
			<v-btn
			  color="successful"
			  @click="cambiarDatos"
			>
			  ACEPTAR
			</v-btn>
		</v-card-actions>
	</v-card>
  </v-dialog>

    <template>
      <Breadcrumbs
        :routes="[
          { name: 'Inicio', to: { name: 'preinscritos' } },
          { name: 'Preinscritos' },
          { name: 'Listado' }
        ]"
      />
      <v-card>
        <v-toolbar
          color="grey darken-4"
          dark
          card
        >
          <v-toolbar-title>Preinscritos</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              v-if="registereds.length"
              sm6
              offset-sm6
            >
              <v-text-field
                v-model="searchUsers"
                :disabled="loadingRegistereds"
                box
                append-icon="search"
                label="Buscar por dni o apellido"
                clearable
                hide-details
              />
            </v-flex>
            <v-flex xs12>
              <v-data-table
                :headers="[
                  { text: 'DNI', value: 'dni' },
                  { text: 'Nombre', value: 'name' },
                  { text: 'Apellido', value: 'father_surname' },
                  { text: 'Carrera', value: 'career' },
                  { text: 'Modalidad de examen', value: 'typeExam' },
                  { text: 'Acciones', align: 'center', sortable: false, width: '220' }
                ]"
                :items="filterData"
                :search="searchUsers"
                :loading="loadingRegistereds"
                class="elevation-1"
              >
                <tr
                  slot="items"
                  slot-scope="props"
                >
                  <td class="px-3">
                    {{ props.item.dni }}
                  </td>
                  <td class="px-3">
                    {{ props.item.name }}
                  </td>
                  <td class="px-3">
                    {{ props.item.father_surname }}
                  </td>
                  <td class="px-3">
                    {{ props.item.career.title }}
                  </td>
                  <td class="px-3">
                    {{ props.item.typeExam.title }}
                  </td>
                  <td>
                    <v-btn
                      color="blue-grey"
                      class="ma-2 white--text"
                      :to="{ name: 'reportePreinscription', params: { id: props.item.id } }"
                    >
                      Ficha Reporte
                      <v-icon
                        right
                        dark
                      >
                        cloud_download
                      </v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-center px-3">
                    <template v-if="$can('update', 'Registereds')">
                      <v-btn
                        class="ma-0"
                        :to="{ name: 'registerEdit', params: { id: props.item.id } }"
                        small
                        icon
                        flat
                        color="info"
                      >
                        <v-icon small>
                          edit
                        </v-icon>
                      </v-btn>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small icon flat v-on="on">
                            <v-icon small>
								book
							</v-icon>
						  </v-btn>
                        </template>
                        <v-list>
                          <v-list-tile v-on:click="cambiarCarrera(props.item)">
						  	<v-list-tile-title>Cambiar datos de preinscripción</v-list-tile-title>
						  </v-list-tile>
                          <v-list-tile v-on:click="anularPreinscripcion(props.item)">
						  	<v-list-tile-title>Anular preinscripción</v-list-tile-title>
						  </v-list-tile>
                        </v-list>
                      </v-menu>
                    </template>
                  </td>
                </tr>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  middleware: 'auth',

  metaInfo () {
    return { title: 'Listado de Preinscritos' }
  },
  components: {
    NotPermission: () => import('@/views/errors/NotPermission'),
    Breadcrumbs: () => import('@/components/Breadcrumbs')
  },
  data () {
    return {
      searchUsers: '',
      excel_path: '',
	  dialogCambioVisible: false,
	  change: {
	  	id: '',
	  	career_id: '',
		type_exam_id: ''
	  }
    }
  },
  computed: {
    ...mapState({
      currentRegistred: state => state.register.replaceCurrentRegistered,
      registereds: state => state.register.registereds,
      loadingRegistereds: state => state.register.loadingRegistereds,
	  careers: state => state.careers.careers,
	  exams: state => state.typeExams.typeexams,
    }),
    filterData () {
      let registereds = this.registereds
      return registereds.filter(o => o.typeExam.id != 185)
    }
  },
  created () {
    if (!this.$can('list', 'Registereds')) return false
    this.getRegistereds({
      confirmed: false
    })
	this.getExams()
	this.getCareers()
  },
  methods: {
    ...mapActions({
      getRegistereds: 'register/getRegistereds',
      replaceCurrentRegistered: 'register/replaceCurrentRegistered',
      replaceRegistereds: 'register/replaceRegistereds',
      getCareers: 'careers/getCareers',
      getExams: 'typeExams/getExams',
      patchBasics: 'register/patchBasics',
	  deleteRegistered: 'register/deleteInscribed',
    }),
	cambiarDatos(props) {
		this.dialogCambioVisible = false;
		var mw = this;
		this.patchBasics({...this.change}).then(data => {
			mw.getRegistereds({confirmed: false});
		});
	},
	cambiarCarrera(props) {
		console.log(props);
		this.change.id = props.id;
		this.change.career_id = props.career.id;
		this.change.type_exam_id = props.typeExam.id;
		this.dialogCambioVisible = true;
	},
	anularPreinscripcion(id) {
		console.log(id);
		if(!window.confirm('Eliminar esta preinscripción')) return;
		this.deleteRegistered(id).then(data => {
			this.getRegistereds({confirmed: false});
		});
	},
  }
}
</script>
